import React from 'react';
import { Field } from 'formik';
import CurrencyFormat from 'react-currency-format';

const CurrencyFormatInput = ({
                               type,
                               name,
                               backendError,
                               onChange,
                               onFocus,
                               customInput,
                               index,
                             }) => {

  function validate(value) {
    if (value === '') {
      return 'Price is a required field.'
    }
  }

  return (
    <Field type={type} name={name} validate={validate}>
      {({ field, form }) => {
        const error = backendError || (form?.errors?.ispConfiguration?.services && form?.errors?.ispConfiguration?.services[index]?.price);
        return <CurrencyFormat
          prefix={'$ '}
          value={field.value}
          allowNegative={false}
          customInput={(props) => customInput({
            ...props,
            error: error,
            helperText: error,
          })}
          fixedDecimalScale={true}
          decimalScale={2}
          onBlur={async (e) => {
            const value = e.target.value.replace('$ ', '');
            await form.setFieldValue(name, value);
            onChange && onChange(name, value);
          }}
          thousandSeparator={','}
          onFocus={onFocus}
        />;
      }}
    </Field>
  );
};

export default CurrencyFormatInput;
